export default __webpack_public_path__ + "static/media/carousel-4.20ebe00f.png";